import { jsx } from 'react/jsx-runtime';
import { Fragment } from 'react';
import { useIsKeyHeld } from './useIsKeyHeld.es.js';

const visuallyHidden = "_visually-hidden_1swvj_1";
const styles = {
	visuallyHidden: visuallyHidden
};

const VisuallyHidden = (props) => {
  const isAltKeyHeld = useIsKeyHeld("Alt");
  if (isAltKeyHeld) {
    return jsx(Fragment, { children: props.children });
  }
  return jsx("span", { className: styles.visuallyHidden, "data-testid": "visually-hidden", children: props.children });
};

export { VisuallyHidden };
//# sourceMappingURL=VisuallyHidden.es.js.map
